import Vue from 'vue';
import store from '../../store/index';

const logger = {
  error(title, data) {
    if (Vue.rollbar) {
      Vue.rollbar.error(store.state);
      Vue.rollbar.error(title);
    }
  },
};

export default logger;